
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4IbNl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4ac56757d01c03c0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $4ac56757d01c03c0$export$2e2bcd8739ae039 = {
    'fabric.elements.mentions.team.member.50plus': "\uD300 \u2022 \uAD6C\uC131\uC6D0 50\uBA85 \uC774\uC0C1",
    'fabric.elements.mentions.team.member.50plus.including.you': "\uD300 \u2022 \uC790\uC2E0\uC744 \uD3EC\uD568\uD558\uC5EC \uAD6C\uC131\uC6D0 50\uBA85 \uC774\uC0C1",
    'fabric.elements.mentions.team.member.count': "{0, plural, other {\uD300 \u2022 \uAD6C\uC131\uC6D0 {0}\uBA85}}",
    'fabric.elements.mentions.team.member.count.including.you': "{0, plural, other {\uD300 \u2022 \uC790\uC2E0\uC744 \uD3EC\uD568\uD558\uC5EC \uAD6C\uC131\uC6D0 {0}\uBA85}}",
    'fabric.elements.mentions.xproduct.mention.description': "Confluence\uC5D0 \uB300\uD55C \uC561\uC138\uC2A4 \uAD8C\uD55C \uD544\uC694",
    'fabric.mention.error.defaultAction': "\uBA87 \uCD08 \uD6C4\uC5D0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC2ED\uC2DC\uC624",
    'fabric.mention.error.defaultHeadline': "\uBB38\uC81C\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4",
    'fabric.mention.error.differentText': "\uB2E4\uB978 \uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD574 \uBCF4\uC2ED\uC2DC\uC624",
    'fabric.mention.error.loginAgain': "\uB85C\uADF8\uC544\uC6C3\uD55C \uB2E4\uC74C \uB2E4\uC2DC \uB85C\uADF8\uC778\uD574 \uBCF4\uC2ED\uC2DC\uC624",
    'fabric.mention.noAccess.label': "\uC561\uC138\uC2A4 \uAD8C\uD55C \uC5C6\uC74C",
    'fabric.mention.noAccess.warning': "{name}\uC740(\uB294) \uC561\uC138\uC2A4 \uAD8C\uD55C\uC774 \uC5C6\uC5B4 \uC54C\uB9BC\uC744 \uBC1B\uC9C0 \uBABB\uD569\uB2C8\uB2E4",
    'fabric.mention.unknow.user.error': "\uC54C \uC218 \uC5C6\uB294 \uC0AC\uC6A9\uC790 {userId}"
};

});


//# sourceMappingURL=ko.419acfa2.js.map
